<div class="dz-grid">
	<ng-container *ngIf="isAuthenticated$ | async; else cwpTemplate">
		<div data-cy="heading-and-download-btn-section" class="dz-row padding-top-object-6 padding-bottom-24">
			<div class="dz-col-12">
				<p class="dz-text-12-extra-bold padding-bottom-object-4" dcrHTMLKey="ME_TITLE">MODEL EVALUATOR</p>
				<p class="dz-text-20-bold dz-text-md-36-bold" dcrHTMLKey="ME_FIND_COMPARE_HEADER">Explore available model portfolios</p>
			</div>

			<div class="dz-col-4 dz-align-self-center padding-right-0">
				<button
					dz-button
					class="pull-right dz-hidden dz-block-md"
					custom-tracking
					[track-event]="tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME + 'header:header clicks:generate report-all (without performance)'"
					(click)="onDownloadAllPdfReportClick(true)"
					*ngIf="showDownloadAllPdfButton && downloadAllPdf"
				>
					<dz-icon class="color-blk-orange padding-right-10" type="file-pdf"></dz-icon>
					<span dcrHTMLKey="DOWNLOAD_All_PDF_WITHOUT_PERFORMANCE">Download All PDF (Without Performance)</span>
				</button>
			</div>
			<div class="dz-col-4 dz-align-self-center">
				<button
					dz-button
					class="pull-right dz-hidden dz-block-md"
					custom-tracking
					[track-event]="tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME + 'header:header clicks:generate report-all'"
					(click)="onDownloadAllPdfReportClick()"
					*ngIf="showDownloadAllPdfButton && downloadAllPdf"
				>
					<dz-icon class="color-blk-orange padding-right-10" type="file-pdf"></dz-icon>
					<span dcrHTMLKey="DOWNLOAD_All_PDF">Download All PDF</span>
				</button>
			</div>
			<div class="dz-col-4 dz-align-self-center">
				<button
					dz-button
					class="pull-right dz-hidden dz-block-md"
					custom-tracking
					[track-event]="
						tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME +
						':' +
						tealiumConstants.MODELS_EXPERIENCE_EVENTS.FIND_AND_COMPARE_PAGE +
						':button:download holdings'
					"
					(click)="onDownloadHoldingsClick()"
					*ngIf="showDownloadButton"
				>
					<dz-icon class="color-blk-orange padding-right-10" type="file-excel"></dz-icon>
					<span dcrHTMLKey="MENU_DOWNLOAD_HOLDINGS">Download Holdings</span>
				</button>
			</div>
		</div>
		<ng-container *ngIf="!hideFiltersAndCount">
			<mb-highlighted-filters
				class="dz-hidden dz-block-md"
				[highlightedFilters]="highlightedFilters"
				[urlFilters]="selectedHighlightedFiltersFromUrl"
				(onSelectFilters)="getSelectedFilters($event)"
			></mb-highlighted-filters>
			<mb-dropdown-filters
				class="dz-hidden dz-block-md"
				[filtersList]="dropdownFilters"
				[selectedHighlightedFilterConfig]="selectedHighlightedFilterConfig"
				[urlFilters]="selectedDropdownFiltersFromUrl"
				(selectedDropdownFilters)="getSelectedDropdownFilters($event)"
			></mb-dropdown-filters>
			<div *ngIf="selectedFilters.length" class="dz-hidden dz-block-md padding-bottom-layout-2-lg padding-bottom-layout-1 dz-text-align-right-md dz-text-align-left-xl">
				<dz-microaction icon="times-circle" (menuItemClick)="clearAllFilters()">
					<span dcrHTMLKey="CLEAR_ALL_LABEL">Clear All</span>
				</dz-microaction>
			</div>
		</ng-container>
	</ng-container>
	<ng-template #cwpTemplate>
		<div cwpComponent></div>
	</ng-template>
	<main class="dz-text-align-left">
		<ng-container *ngIf="isLoading; else familiesContent">
			<div class="padding-top-object-3">
				<mb-families-container-skeleton></mb-families-container-skeleton>
			</div>
		</ng-container>
		<ng-template #familiesContent>
			<div
				class="dz-block dz-flex-md margin-bottom-object-5 margin-bottom-object-0-md"
				[ngClass]="{ 'dz-justify-content-right': hideFiltersAndCount, 'dz-justify-content-between': !hideFiltersAndCount }"
			>
				<div class="dz-flex">
					<dz-search
						[isExpanded]="true"
						*ngIf="showSearchButton && isAuthenticated$ | async"
						(searchFilterValueChange)="searchKeyword($event)"
						class="search-button"
					></dz-search>
					<div class="dz-hidden dz-block-md dz-text-16-bold padding-5" data-cy="models-count" *ngIf="!hideFiltersAndCount">
						{{ modelCount }} <span dcrHTMLKey="MODEL_COUNT_TEXT">results</span>
					</div>
				</div>
				<button dz-small-button color="secondary" class="dz-pull-left dz-hidden-md" *ngIf="!hideFiltersAndCount" (click)="showMobileFilters = !showMobileFilters">
					<span dcrHTMLKey="FIND_COMPARE_MOBILE_FILTER">Filter</span>
					<dz-icon class="color-blk-orange padding-left-10" type="filter"></dz-icon>
				</button>

				<div class="dz-col-md-12 dz-hidden-lg dz-text-align-right dz-text-14-bold clickable padding-object-0-md padding-5" (click)="updateSortByLatestTrade()">
					<span dcrHTMLKey="LATEST_TRADE_DATE_HEADER_LABEL">Latest Trade Date </span>
					<dz-icon class="icon" [ngClass]="{ active: sortByLatestTrade, inactive: !sortByLatestTrade }" type="caret-down"></dz-icon>
				</div>
				<div *ngIf="(isAuthenticated$ | async) && isCustomFeeEnabled" class="custom-fee-button-container dz-hidden dz-block-md">
					<cfe-custom-advisory-fee-dialog-button [customAdvisoryFee]="customAdvisoryFee$ | async" [showCurrentFee]="true"></cfe-custom-advisory-fee-dialog-button>
				</div>
			</div>

			<div class="dz-hidden dz-block-md dz-text-12 dz-col-md-4 padding-bottom-layout-1 padding-bottom-layout-0-lg" *ngIf="selectedFilters.length || searchText.length">
				<span dcrHTMLKey="PORTFOLIO_COUNT_DISCLOSURE">PORTFOLIO_COUNT_DISCLOSURE</span>
			</div>

			<ng-container *ngIf="(familyIdsPerCategory | keyvalue)?.length; else emptyTemplate">
				<bfa-tabs type="underline" [hideTabBarIfOneTab]="true" (activeTabPanelChange)="handleFiltersVisibility($event)">
					<ng-container *ngFor="let category of categories">
						<!-- Tab header -->
						<tab-panel
							[tab-title]="(category === 'blackrock_family_group' ? 'BlackRock Models' : 'Your Custom Models') | dcr : category + '_tab'"
							[templateRef]="tabContent"
						></tab-panel>
						<!-- Tab detail -->
						<ng-template #tabContent>
							<div [dcrHTMLKey]="category + '_tab_description'"></div>
							<section class="dz-row dz-text-14-bold padding-bottom-object-2-lg padding-top-object-6-lg family-list-header">
								<div class="dz-col-lg-4 dz-hidden dz-block-lg"><span dcrHTMLKey="MODEL_FAMILY_HEADER_LABEL">Model Family</span></div>
								<div class="dz-col-lg-6 dz-hidden dz-block-lg"><span dcrHTMLKey="OBJECTIVE_HEADER_LABEL">Objective</span></div>
								<div class="dz-col-lg-3 dz-hidden dz-block-lg"><span dcrHTMLKey="VEHICLE_HEADER_LABEL">Vehicle</span></div>
								<div class="dz-col-lg-3 dz-hidden dz-block-lg"><span dcrHTMLKey="TRADE_FREQUENCY_HEADER_LABEL">Trade Frequency</span></div>
								<div
									class="dz-col-lg-3 dz-col-md-12 dz-col-10 dz-hidden dz-block-lg dz-text-align-right margin-bottom-object-2-md clickable"
									(click)="updateSortByLatestTrade()"
								>
									<span dcrHTMLKey="LATEST_TRADE_DATE_HEADER_LABEL">Latest Trade Date </span>
									<dz-icon class="icon" [ngClass]="{ active: sortByLatestTrade, inactive: !sortByLatestTrade }" type="caret-down"></dz-icon>
								</div>
								<div class="dz-col-5 dz-col-sm-5 dz-hidden-md dz-block-lg"></div>
							</section>
							<mb-family-list
								*componentId="{ componentId: 'me.families', ids: familyIdsPerCategory[category] }; let res"
								[data]="res"
								[searchText]="searchText"
								[groupId]="category"
								[category]="groupIdNames[category]"
								[familyModelsMapping]="familyModelsPerCategory ? familyModelsPerCategory[category] : null"
								[selectedModelsToCompare]="selectedModelsToCompare"
								[sortByLatestTradeDate]="sortByLatestTrade"
								[selectedFilters]="selectedFilters"
								[isAuthenticated]="isAuthenticated$ | async"
								[selectedFamilyId]="selectedFamilyId"
								(selectedModels)="setSelectedModelsToCompare($event)"
								(filteredModelsCount)="showFilteredModelsCount($event)"
							></mb-family-list>
						</ng-template>
					</ng-container>
				</bfa-tabs>
			</ng-container>
		</ng-template>
	</main>
	<div class="margin-top-16">
		<ac-disclosure *ngIf="isAuthenticated$ | async" dcrKey="ME_FAMILY_DETAILS_DISCLOSURE"></ac-disclosure>
	</div>
</div>

<ng-template #emptyTemplate>
	<mb-model-list-empty-container subTextDCR="FIND_COMPARE_NO_MODEL_FAMILIES"></mb-model-list-empty-container>
</ng-template>

<me-mini-compare-bar
	*ngIf="selectedModelsToCompare?.length"
	[selectedModelsToCompare]="selectedModelsToCompare"
	(openMiniCompareDialog)="onOpenMiniCompareDialog($event)"
	(removeSelectedModel)="onRemoveSelectedModelsData($event)"
></me-mini-compare-bar>

<div *ngIf="showMobileFilters" class="filter-overlay dz-hidden-md">
	<div class="dz-grid">
		<div class="dz-row dz-row-breakout padding-vertical-layout-2 margin-bottom-layout-1 overlay-header">
			<div dcrHtmlKey="FIND_COMPARE_MOBILE_FILTERS" class="dz-col-22 dz-inline-block dz-text-16-bold dz-text-align-center">Filters</div>
			<dz-icon type="times" class="dz-col-2 dz-align-self-center" (click)="showMobileFilters = !showMobileFilters"></dz-icon>
		</div>
	</div>
	<dz-block-alert *ngIf="showMobileFilterWarningMsg" type="warning" class="dz-block margin-bottom-layout-2">
		<div class="dz-flex">
			<div dcrHTMLKey="MOBILE_FILTER_WARNING_MSG">To view specific portfolios within these filters, please switch to desktop version</div>
			<dz-icon type="times" class="dz-align-self-center" (click)="showMobileFilterWarningMsg = !showMobileFilterWarningMsg"></dz-icon>
		</div>
	</dz-block-alert>
	<mb-dropdown-filters
		[filtersList]="dropdownFilters"
		[selectedHighlightedFilterConfig]="selectedHighlightedFilterConfig"
		[urlFilters]="selectedDropdownFiltersFromUrl"
		(selectedDropdownFilters)="selectedDropdownFiltersFromMobileModal = $event"
	></mb-dropdown-filters>
	<div class="dz-flex dz-justify-content-center margin-top-object-8">
		<button
			dz-button
			dcrHTMLKey="APPLY_FILTERS_BUTTON_TEXT"
			custom-tracking
			[track-event]="
				tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME +
				':' +
				tealiumConstants.MODELS_EXPERIENCE_EVENTS.FIND_AND_COMPARE_PAGE +
				'mobile:button:apply filters'
			"
			(click)="applySelectedFilters()"
		>
			Apply
		</button>
	</div>
</div>
